export const prefixes = [
    {
        id: 'IT',
        value: 'IT',
        label: '+39',
    },
    {
        id: 'AF',
        value: 'AF',
        label: '+93',
    },
    {
        id: 'AL',
        value: 'AL',
        label: '+355',
    },
    {
        id: 'DZ',
        value: 'DZ',
        label: '+213',
    },
    {
        id: 'AS',
        value: 'AS',
        label: '+1-684',
    },
    {
        id: 'AD',
        value: 'AD',
        label: '+376',
    },
    {
        id: 'AO',
        value: 'AO',
        label: '+244',
    },
    {
        id: 'AI',
        value: 'AI',
        label: '+1-264',
    },
    {
        id: 'AQ',
        value: 'AQ',
        label: '+672',
    },
    {
        id: 'AG',
        value: 'AG',
        label: '+1-268',
    },
    {
        id: 'AR',
        value: 'AR',
        label: '+54',
    },
    {
        id: 'AM',
        value: 'AM',
        label: '+374',
    },
    {
        id: 'AW',
        value: 'AW',
        label: '+297',
    },
    {
        id: 'AU',
        value: 'AU',
        label: '+61',
    },
    {
        id: 'AT',
        value: 'AT',
        label: '+43',
    },
    {
        id: 'AZ',
        value: 'AZ',
        label: '+994',
    },
    {
        id: 'BS',
        value: 'BS',
        label: '+1-242',
    },
    {
        id: 'BH',
        value: 'BH',
        label: '+973',
    },
    {
        id: 'BD',
        value: 'BD',
        label: '+880',
    },
    {
        id: 'BB',
        value: 'BB',
        label: '+1-246',
    },
    {
        id: 'BY',
        value: 'BY',
        label: '+375',
    },
    {
        id: 'BE',
        value: 'BE',
        label: '+32',
    },
    {
        id: 'BZ',
        value: 'BZ',
        label: '+501',
    },
    {
        id: 'BJ',
        value: 'BJ',
        label: '+229',
    },
    {
        id: 'BM',
        value: 'BM',
        label: '+1-441',
    },
    {
        id: 'BT',
        value: 'BT',
        label: '+975',
    },
    {
        id: 'BO',
        value: 'BO',
        label: '+591',
    },
    {
        id: 'BA',
        value: 'BA',
        label: '+387',
    },
    {
        id: 'BW',
        value: 'BW',
        label: '+267',
    },
    {
        id: 'BR',
        value: 'BR',
        label: '+55',
    },
    {
        id: 'IO',
        value: 'IO',
        label: '+246',
    },
    {
        id: 'VG',
        value: 'VG',
        label: '+1-284',
    },
    {
        id: 'BN',
        value: 'BN',
        label: '+673',
    },
    {
        id: 'BG',
        value: 'BG',
        label: '+359',
    },
    {
        id: 'BF',
        value: 'BF',
        label: '+226',
    },
    {
        id: 'BI',
        value: 'BI',
        label: '+257',
    },
    {
        id: 'KH',
        value: 'KH',
        label: '+855',
    },
    {
        id: 'CM',
        value: 'CM',
        label: '+237',
    },
    {
        id: 'CA',
        value: 'CA',
        label: '+1',
    },
    {
        id: 'CV',
        value: 'CV',
        label: '+238',
    },
    {
        id: 'KY',
        value: 'KY',
        label: '+1-345',
    },
    {
        id: 'CF',
        value: 'CF',
        label: '+236',
    },
    {
        id: 'TD',
        value: 'TD',
        label: '+235',
    },
    {
        id: 'CL',
        value: 'CL',
        label: '+56',
    },
    {
        id: 'CN',
        value: 'CN',
        label: '+86',
    },
    {
        id: 'CX',
        value: 'CX',
        label: '+61',
    },
    {
        id: 'CC',
        value: 'CC',
        label: '+61',
    },
    {
        id: 'CO',
        value: 'CO',
        label: '+57',
    },
    {
        id: 'KM',
        value: 'KM',
        label: '+269',
    },
    {
        id: 'CK',
        value: 'CK',
        label: '+682',
    },
    {
        id: 'CR',
        value: 'CR',
        label: '+506',
    },
    {
        id: 'HR',
        value: 'HR',
        label: '+385',
    },
    {
        id: 'CU',
        value: 'CU',
        label: '+53',
    },
    {
        id: 'CW',
        value: 'CW',
        label: '+599',
    },
    {
        id: 'CY',
        value: 'CY',
        label: '+357',
    },
    {
        id: 'CZ',
        value: 'CZ',
        label: '+420',
    },
    {
        id: 'CD',
        value: 'CD',
        label: '+243',
    },
    {
        id: 'DK',
        value: 'DK',
        label: '+45',
    },
    {
        id: 'DJ',
        value: 'DJ',
        label: '+253',
    },
    {
        id: 'DM',
        value: 'DM',
        label: '+1-767',
    },
    {
        id: 'DO',
        value: 'DO',
        label: '+1-809, 1-829, 1-849',
    },
    {
        id: 'TL',
        value: 'TL',
        label: '+670',
    },
    {
        id: 'EC',
        value: 'EC',
        label: '+593',
    },
    {
        id: 'EG',
        value: 'EG',
        label: '+20',
    },
    {
        id: 'SV',
        value: 'SV',
        label: '+503',
    },
    {
        id: 'GQ',
        value: 'GQ',
        label: '+240',
    },
    {
        id: 'ER',
        value: 'ER',
        label: '+291',
    },
    {
        id: 'EE',
        value: 'EE',
        label: '+372',
    },
    {
        id: 'ET',
        value: 'ET',
        label: '+251',
    },
    {
        id: 'FK',
        value: 'FK',
        label: '+500',
    },
    {
        id: 'FO',
        value: 'FO',
        label: '+298',
    },
    {
        id: 'FJ',
        value: 'FJ',
        label: '+679',
    },
    {
        id: 'FI',
        value: 'FI',
        label: '+358',
    },
    {
        id: 'FR',
        value: 'FR',
        label: '+33',
    },
    {
        id: 'PF',
        value: 'PF',
        label: '+689',
    },
    {
        id: 'GA',
        value: 'GA',
        label: '+241',
    },
    {
        id: 'GM',
        value: 'GM',
        label: '+220',
    },
    {
        id: 'GE',
        value: 'GE',
        label: '+995',
    },
    {
        id: 'DE',
        value: 'DE',
        label: '+49',
    },
    {
        id: 'GH',
        value: 'GH',
        label: '+233',
    },
    {
        id: 'GI',
        value: 'GI',
        label: '+350',
    },
    {
        id: 'GR',
        value: 'GR',
        label: '+30',
    },
    {
        id: 'GL',
        value: 'GL',
        label: '+299',
    },
    {
        id: 'GD',
        value: 'GD',
        label: '+1-473',
    },
    {
        id: 'GU',
        value: 'GU',
        label: '+1-671',
    },
    {
        id: 'GT',
        value: 'GT',
        label: '+502',
    },
    {
        id: 'GG',
        value: 'GG',
        label: '+44-1481',
    },
    {
        id: 'GN',
        value: 'GN',
        label: '+224',
    },
    {
        id: 'GW',
        value: 'GW',
        label: '+245',
    },
    {
        id: 'GY',
        value: 'GY',
        label: '+592',
    },
    {
        id: 'HT',
        value: 'HT',
        label: '+509',
    },
    {
        id: 'HN',
        value: 'HN',
        label: '+504',
    },
    {
        id: 'HK',
        value: 'HK',
        label: '+852',
    },
    {
        id: 'HU',
        value: 'HU',
        label: '+36',
    },
    {
        id: 'IS',
        value: 'IS',
        label: '+354',
    },
    {
        id: 'IN',
        value: 'IN',
        label: '+91',
    },
    {
        id: 'ID',
        value: 'ID',
        label: '+62',
    },
    {
        id: 'IR',
        value: 'IR',
        label: '+98',
    },
    {
        id: 'IQ',
        value: 'IQ',
        label: '+964',
    },
    {
        id: 'IE',
        value: 'IE',
        label: '+353',
    },
    {
        id: 'IM',
        value: 'IM',
        label: '+44-1624',
    },
    {
        id: 'IL',
        value: 'IL',
        label: '+972',
    },
    {
        id: 'CI',
        value: 'CI',
        label: '+225',
    },
    {
        id: 'JM',
        value: 'JM',
        label: '+1-876',
    },
    {
        id: 'JP',
        value: 'JP',
        label: '+81',
    },
    {
        id: 'JE',
        value: 'JE',
        label: '+44-1534',
    },
    {
        id: 'JO',
        value: 'JO',
        label: '+962',
    },
    {
        id: 'KZ',
        value: 'KZ',
        label: '+7',
    },
    {
        id: 'KE',
        value: 'KE',
        label: '+254',
    },
    {
        id: 'KI',
        value: 'KI',
        label: '+686',
    },
    {
        id: 'XK',
        value: 'XK',
        label: '+383',
    },
    {
        id: 'KW',
        value: 'KW',
        label: '+965',
    },
    {
        id: 'KG',
        value: 'KG',
        label: '+996',
    },
    {
        id: 'LA',
        value: 'LA',
        label: '+856',
    },
    {
        id: 'LV',
        value: 'LV',
        label: '+371',
    },
    {
        id: 'LB',
        value: 'LB',
        label: '+961',
    },
    {
        id: 'LS',
        value: 'LS',
        label: '+266',
    },
    {
        id: 'LR',
        value: 'LR',
        label: '+231',
    },
    {
        id: 'LY',
        value: 'LY',
        label: '+218',
    },
    {
        id: 'LI',
        value: 'LI',
        label: '+423',
    },
    {
        id: 'LT',
        value: 'LT',
        label: '+370',
    },
    {
        id: 'LU',
        value: 'LU',
        label: '+352',
    },
    {
        id: 'MO',
        value: 'MO',
        label: '+853',
    },
    {
        id: 'MK',
        value: 'MK',
        label: '+389',
    },
    {
        id: 'MG',
        value: 'MG',
        label: '+261',
    },
    {
        id: 'MW',
        value: 'MW',
        label: '+265',
    },
    {
        id: 'MY',
        value: 'MY',
        label: '+60',
    },
    {
        id: 'MV',
        value: 'MV',
        label: '+960',
    },
    {
        id: 'ML',
        value: 'ML',
        label: '+223',
    },
    {
        id: 'MT',
        value: 'MT',
        label: '+356',
    },
    {
        id: 'MH',
        value: 'MH',
        label: '+692',
    },
    {
        id: 'MR',
        value: 'MR',
        label: '+222',
    },
    {
        id: 'MU',
        value: 'MU',
        label: '+230',
    },
    {
        id: 'YT',
        value: 'YT',
        label: '+262',
    },
    {
        id: 'MX',
        value: 'MX',
        label: '+52',
    },
    {
        id: 'FM',
        value: 'FM',
        label: '+691',
    },
    {
        id: 'MD',
        value: 'MD',
        label: '+373',
    },
    {
        id: 'MC',
        value: 'MC',
        label: '+377',
    },
    {
        id: 'MN',
        value: 'MN',
        label: '+976',
    },
    {
        id: 'ME',
        value: 'ME',
        label: '+382',
    },
    {
        id: 'MS',
        value: 'MS',
        label: '+1-664',
    },
    {
        id: 'MA',
        value: 'MA',
        label: '+212',
    },
    {
        id: 'MZ',
        value: 'MZ',
        label: '+258',
    },
    {
        id: 'MM',
        value: 'MM',
        label: '+95',
    },
    {
        id: 'NA',
        value: 'NA',
        label: '+264',
    },
    {
        id: 'NR',
        value: 'NR',
        label: '+674',
    },
    {
        id: 'NP',
        value: 'NP',
        label: '+977',
    },
    {
        id: 'NL',
        value: 'NL',
        label: '+31',
    },
    {
        id: 'AN',
        value: 'AN',
        label: '+599',
    },
    {
        id: 'NC',
        value: 'NC',
        label: '+687',
    },
    {
        id: 'NZ',
        value: 'NZ',
        label: '+64',
    },
    {
        id: 'NI',
        value: 'NI',
        label: '+505',
    },
    {
        id: 'NE',
        value: 'NE',
        label: '+227',
    },
    {
        id: 'NG',
        value: 'NG',
        label: '+234',
    },
    {
        id: 'NU',
        value: 'NU',
        label: '+683',
    },
    {
        id: 'KP',
        value: 'KP',
        label: '+850',
    },
    {
        id: 'MP',
        value: 'MP',
        label: '+1-670',
    },
    {
        id: 'NO',
        value: 'NO',
        label: '+47',
    },
    {
        id: 'OM',
        value: 'OM',
        label: '+968',
    },
    {
        id: 'PK',
        value: 'PK',
        label: '+92',
    },
    {
        id: 'PW',
        value: 'PW',
        label: '+680',
    },
    {
        id: 'PS',
        value: 'PS',
        label: '+970',
    },
    {
        id: 'PA',
        value: 'PA',
        label: '+507',
    },
    {
        id: 'PG',
        value: 'PG',
        label: '+675',
    },
    {
        id: 'PY',
        value: 'PY',
        label: '+595',
    },
    {
        id: 'PE',
        value: 'PE',
        label: '+51',
    },
    {
        id: 'PH',
        value: 'PH',
        label: '+63',
    },
    {
        id: 'PN',
        value: 'PN',
        label: '+64',
    },
    {
        id: 'PL',
        value: 'PL',
        label: '+48',
    },
    {
        id: 'PT',
        value: 'PT',
        label: '+351',
    },
    {
        id: 'PR',
        value: 'PR',
        label: '+1-787, 1-939',
    },
    {
        id: 'QA',
        value: 'QA',
        label: '+974',
    },
    {
        id: 'CG',
        value: 'CG',
        label: '+242',
    },
    {
        id: 'RE',
        value: 'RE',
        label: '+262',
    },
    {
        id: 'RO',
        value: 'RO',
        label: '+40',
    },
    {
        id: 'RU',
        value: 'RU',
        label: '+7',
    },
    {
        id: 'RW',
        value: 'RW',
        label: '+250',
    },
    {
        id: 'BL',
        value: 'BL',
        label: '+590',
    },
    {
        id: 'SH',
        value: 'SH',
        label: '+290',
    },
    {
        id: 'KN',
        value: 'KN',
        label: '+1-869',
    },
    {
        id: 'LC',
        value: 'LC',
        label: '+1-758',
    },
    {
        id: 'MF',
        value: 'MF',
        label: '+590',
    },
    {
        id: 'PM',
        value: 'PM',
        label: '+508',
    },
    {
        id: 'VC',
        value: 'VC',
        label: '+1-784',
    },
    {
        id: 'WS',
        value: 'WS',
        label: '+685',
    },
    {
        id: 'SM',
        value: 'SM',
        label: '+378',
    },
    {
        id: 'ST',
        value: 'ST',
        label: '+239',
    },
    {
        id: 'SA',
        value: 'SA',
        label: '+966',
    },
    {
        id: 'SN',
        value: 'SN',
        label: '+221',
    },
    {
        id: 'RS',
        value: 'RS',
        label: '+381',
    },
    {
        id: 'SC',
        value: 'SC',
        label: '+248',
    },
    {
        id: 'SL',
        value: 'SL',
        label: '+232',
    },
    {
        id: 'SG',
        value: 'SG',
        label: '+65',
    },
    {
        id: 'SX',
        value: 'SX',
        label: '+1-721',
    },
    {
        id: 'SK',
        value: 'SK',
        label: '+421',
    },
    {
        id: 'SI',
        value: 'SI',
        label: '+386',
    },
    {
        id: 'SB',
        value: 'SB',
        label: '+677',
    },
    {
        id: 'SO',
        value: 'SO',
        label: '+252',
    },
    {
        id: 'ZA',
        value: 'ZA',
        label: '+27',
    },
    {
        id: 'KR',
        value: 'KR',
        label: '+82',
    },
    {
        id: 'SS',
        value: 'SS',
        label: '+211',
    },
    {
        id: 'ES',
        value: 'ES',
        label: '+34',
    },
    {
        id: 'LK',
        value: 'LK',
        label: '+94',
    },
    {
        id: 'SD',
        value: 'SD',
        label: '+249',
    },
    {
        id: 'SR',
        value: 'SR',
        label: '+597',
    },
    {
        id: 'SJ',
        value: 'SJ',
        label: '+47',
    },
    {
        id: 'SZ',
        value: 'SZ',
        label: '+268',
    },
    {
        id: 'SE',
        value: 'SE',
        label: '+46',
    },
    {
        id: 'CH',
        value: 'CH',
        label: '+41',
    },
    {
        id: 'SY',
        value: 'SY',
        label: '+963',
    },
    {
        id: 'TW',
        value: 'TW',
        label: '+886',
    },
    {
        id: 'TJ',
        value: 'TJ',
        label: '+992',
    },
    {
        id: 'TZ',
        value: 'TZ',
        label: '+255',
    },
    {
        id: 'TH',
        value: 'TH',
        label: '+66',
    },
    {
        id: 'TG',
        value: 'TG',
        label: '+228',
    },
    {
        id: 'TK',
        value: 'TK',
        label: '+690',
    },
    {
        id: 'TO',
        value: 'TO',
        label: '+676',
    },
    {
        id: 'TT',
        value: 'TT',
        label: '+1-868',
    },
    {
        id: 'TN',
        value: 'TN',
        label: '+216',
    },
    {
        id: 'TR',
        value: 'TR',
        label: '+90',
    },
    {
        id: 'TM',
        value: 'TM',
        label: '+993',
    },
    {
        id: 'TC',
        value: 'TC',
        label: '+1-649',
    },
    {
        id: 'TV',
        value: 'TV',
        label: '+688',
    },
    {
        id: 'VI',
        value: 'VI',
        label: '+1-340',
    },
    {
        id: 'UG',
        value: 'UG',
        label: '+256',
    },
    {
        id: 'UA',
        value: 'UA',
        label: '+380',
    },
    {
        id: 'AE',
        value: 'AE',
        label: '+971',
    },
    {
        id: 'GB',
        value: 'GB',
        label: '+44',
    },
    {
        id: 'US',
        value: 'US',
        label: '+1',
    },
    {
        id: 'UY',
        value: 'UY',
        label: '+598',
    },
    {
        id: 'UZ',
        value: 'UZ',
        label: '+998',
    },
    {
        id: 'VU',
        value: 'VU',
        label: '+678',
    },
    {
        id: 'VA',
        value: 'VA',
        label: '+379',
    },
    {
        id: 'VE',
        value: 'VE',
        label: '+58',
    },
    {
        id: 'VN',
        value: 'VN',
        label: '+84',
    },
    {
        id: 'WF',
        value: 'WF',
        label: '+681',
    },
    {
        id: 'EH',
        value: 'EH',
        label: '+212',
    },
    {
        id: 'YE',
        value: 'YE',
        label: '+967',
    },
    {
        id: 'ZM',
        value: 'ZM',
        label: '+260',
    },
    {
        id: 'ZW',
        value: 'ZW',
        label: '+263',
    },
];

export const provinces = [
    {
        id: 'AG',
        value: 'AG',
        label: 'Agrigento',
    },
    {
        id: 'AL',
        value: 'AL',
        label: 'Alessandria',
    },
    {
        id: 'AN',
        value: 'AN',
        label: 'Ancona',
    },
    {
        id: 'AR',
        value: 'AR',
        label: 'Arezzo',
    },
    {
        id: 'AP',
        value: 'AP',
        label: 'Ascoli Piceno',
    },
    {
        id: 'AT',
        value: 'AT',
        label: 'Asti',
    },
    {
        id: 'AV',
        value: 'AV',
        label: 'Avellino',
    },
    {
        id: 'BA',
        value: 'BA',
        label: 'Bari',
    },
    {
        id: 'BT',
        value: 'BT',
        label: 'Barletta-Andria-Trani',
    },
    {
        id: 'BL',
        value: 'BL',
        label: 'Belluno',
    },
    {
        id: 'BN',
        value: 'BN',
        label: 'Benevento',
    },
    {
        id: 'BG',
        value: 'BG',
        label: 'Bergamo',
    },
    {
        id: 'BI',
        value: 'BI',
        label: 'Biella',
    },
    {
        id: 'BO',
        value: 'BO',
        label: 'Bologna',
    },
    {
        id: 'BZ',
        value: 'BZ',
        label: 'Bolzano/Bozen',
    },
    {
        id: 'BS',
        value: 'BS',
        label: 'Brescia',
    },
    {
        id: 'BR',
        value: 'BR',
        label: 'Brindisi',
    },
    {
        id: 'CA',
        value: 'CA',
        label: 'Cagliari',
    },
    {
        id: 'CL',
        value: 'CL',
        label: 'Caltanissetta',
    },
    {
        id: 'CB',
        value: 'CB',
        label: 'Campobasso',
    },
    {
        id: 'CI',
        value: 'CI',
        label: 'Carbonia-Iglesias',
    },
    {
        id: 'CE',
        value: 'CE',
        label: 'Caserta',
    },
    {
        id: 'CT',
        value: 'CT',
        label: 'Catania',
    },
    {
        id: 'CZ',
        value: 'CZ',
        label: 'Catanzaro',
    },
    {
        id: 'CH',
        value: 'CH',
        label: 'Chieti',
    },
    {
        id: 'CO',
        value: 'CO',
        label: 'Como',
    },
    {
        id: 'CS',
        value: 'CS',
        label: 'Cosenza',
    },
    {
        id: 'CR',
        value: 'CR',
        label: 'Cremona',
    },
    {
        id: 'KR',
        value: 'KR',
        label: 'Crotone',
    },
    {
        id: 'CN',
        value: 'CN',
        label: 'Cuneo',
    },
    {
        id: 'EN',
        value: 'EN',
        label: 'Enna',
    },
    {
        id: 'FM',
        value: 'FM',
        label: 'Fermo',
    },
    {
        id: 'FE',
        value: 'FE',
        label: 'Ferrara',
    },
    {
        id: 'FI',
        value: 'FI',
        label: 'Firenze',
    },
    {
        id: 'FG',
        value: 'FG',
        label: 'Foggia',
    },
    {
        id: 'FC',
        value: 'FC',
        label: 'Forlì-Cesena',
    },
    {
        id: 'FR',
        value: 'FR',
        label: 'Frosinone',
    },
    {
        id: 'GE',
        value: 'GE',
        label: 'Genova',
    },
    {
        id: 'GO',
        value: 'GO',
        label: 'Gorizia',
    },
    {
        id: 'GR',
        value: 'GR',
        label: 'Grosseto',
    },
    {
        id: 'IM',
        value: 'IM',
        label: 'Imperia',
    },
    {
        id: 'IS',
        value: 'IS',
        label: 'Isernia',
    },
    {
        id: 'AQ',
        value: 'AQ',
        label: "L'Aquila",
    },
    {
        id: 'SP',
        value: 'SP',
        label: 'La Spezia',
    },
    {
        id: 'LT',
        value: 'LT',
        label: 'Latina',
    },
    {
        id: 'LE',
        value: 'LE',
        label: 'Lecce',
    },
    {
        id: 'LC',
        value: 'LC',
        label: 'Lecco',
    },
    {
        id: 'LI',
        value: 'LI',
        label: 'Livorno',
    },
    {
        id: 'LO',
        value: 'LO',
        label: 'Lodi',
    },
    {
        id: 'LU',
        value: 'LU',
        label: 'Lucca',
    },
    {
        id: 'MC',
        value: 'MC',
        label: 'Macerata',
    },
    {
        id: 'MN',
        value: 'MN',
        label: 'Mantova',
    },
    {
        id: 'MS',
        value: 'MS',
        label: 'Massa-Carrara',
    },
    {
        id: 'MT',
        value: 'MT',
        label: 'Matera',
    },
    {
        id: 'VS',
        value: 'VS',
        label: 'Medio Campidano',
    },
    {
        id: 'ME',
        value: 'ME',
        label: 'Messina',
    },
    {
        id: 'MI',
        value: 'MI',
        label: 'Milano',
    },
    {
        id: 'MO',
        value: 'MO',
        label: 'Modena',
    },
    {
        id: 'MB',
        value: 'MB',
        label: 'Monza e della Brianza',
    },
    {
        id: 'NA',
        value: 'NA',
        label: 'Napoli',
    },
    {
        id: 'NO',
        value: 'NO',
        label: 'Novara',
    },
    {
        id: 'NU',
        value: 'NU',
        label: 'Nuoro',
    },
    {
        id: 'OG',
        value: 'OG',
        label: 'Ogliastra',
    },
    {
        id: 'OT',
        value: 'OT',
        label: 'Olbia-Tempio',
    },
    {
        id: 'OR',
        value: 'OR',
        label: 'Oristano',
    },
    {
        id: 'PD',
        value: 'PD',
        label: 'Padova',
    },
    {
        id: 'PA',
        value: 'PA',
        label: 'Palermo',
    },
    {
        id: 'PR',
        value: 'PR',
        label: 'Parma',
    },
    {
        id: 'PV',
        value: 'PV',
        label: 'Pavia',
    },
    {
        id: 'PG',
        value: 'PG',
        label: 'Perugia',
    },
    {
        id: 'PU',
        value: 'PU',
        label: 'Pesaro e Urbino',
    },
    {
        id: 'PE',
        value: 'PE',
        label: 'Pescara',
    },
    {
        id: 'PC',
        value: 'PC',
        label: 'Piacenza',
    },
    {
        id: 'PI',
        value: 'PI',
        label: 'Pisa',
    },
    {
        id: 'PT',
        value: 'PT',
        label: 'Pistoia',
    },
    {
        id: 'PN',
        value: 'PN',
        label: 'Pordenone',
    },
    {
        id: 'PZ',
        value: 'PZ',
        label: 'Potenza',
    },
    {
        id: 'PO',
        value: 'PO',
        label: 'Prato',
    },
    {
        id: 'RG',
        value: 'RG',
        label: 'Ragusa',
    },
    {
        id: 'RA',
        value: 'RA',
        label: 'Ravenna',
    },
    {
        id: 'RC',
        value: 'RC',
        label: 'Reggio di Calabria',
    },
    {
        id: 'RE',
        value: 'RE',
        label: "Reggio nell'Emilia",
    },
    {
        id: 'RI',
        value: 'RI',
        label: 'Rieti',
    },
    {
        id: 'RN',
        value: 'RN',
        label: 'Rimini',
    },
    {
        id: 'RM',
        value: 'RM',
        label: 'Roma',
    },
    {
        id: 'RO',
        value: 'RO',
        label: 'Rovigo',
    },
    {
        id: 'SA',
        value: 'SA',
        label: 'Salerno',
    },
    {
        id: 'SS',
        value: 'SS',
        label: 'Sassari',
    },
    {
        id: 'SV',
        value: 'SV',
        label: 'Savona',
    },
    {
        id: 'SI',
        value: 'SI',
        label: 'Siena',
    },
    {
        id: 'SR',
        value: 'SR',
        label: 'Siracusa',
    },
    {
        id: 'SO',
        value: 'SO',
        label: 'Sondrio',
    },
    {
        id: 'TA',
        value: 'TA',
        label: 'Taranto',
    },
    {
        id: 'TE',
        value: 'TE',
        label: 'Teramo',
    },
    {
        id: 'TR',
        value: 'TR',
        label: 'Terni',
    },
    {
        id: 'TO',
        value: 'TO',
        label: 'Torino',
    },
    {
        id: 'TP',
        value: 'TP',
        label: 'Trapani',
    },
    {
        id: 'TN',
        value: 'TN',
        label: 'Trento',
    },
    {
        id: 'TV',
        value: 'TV',
        label: 'Treviso',
    },
    {
        id: 'TS',
        value: 'TS',
        label: 'Trieste',
    },
    {
        id: 'UD',
        value: 'UD',
        label: 'Udine',
    },
    {
        id: 'AO',
        value: 'AO',
        label: "Valle d'Aosta/Vallée d'Aoste",
    },
    {
        id: 'VA',
        value: 'VA',
        label: 'Varese',
    },
    {
        id: 'VE',
        value: 'VE',
        label: 'Venezia',
    },
    {
        id: 'VB',
        value: 'VB',
        label: 'Verbano-Cusio-Ossola',
    },
    {
        id: 'VC',
        value: 'VC',
        label: 'Vercelli',
    },
    {
        id: 'VR',
        value: 'VR',
        label: 'Verona',
    },
    {
        id: 'VV',
        value: 'VV',
        label: 'Vibo Valentia',
    },
    {
        id: 'VI',
        value: 'VI',
        label: 'Vicenza',
    },
    {
        id: 'VT',
        value: 'VT',
        label: 'Viterbo',
    },
];

export const countries = [
    {
        id: 'AF',
        value: 'AF',
        label: 'Afghanistan (AF)',
    },
    {
        id: 'AX',
        value: 'AX',
        label: 'Isole Åland (AX)',
    },
    {
        id: 'AL',
        value: 'AL',
        label: 'Albania (AL)',
    },
    {
        id: 'DZ',
        value: 'DZ',
        label: 'Algeria (DZ)',
    },
    {
        id: 'AS',
        value: 'AS',
        label: 'Samoa Americane (AS)',
    },
    {
        id: 'AD',
        value: 'AD',
        label: 'Andorra (AD)',
    },
    {
        id: 'AO',
        value: 'AO',
        label: 'Angola (AO)',
    },
    {
        id: 'AI',
        value: 'AI',
        label: 'Anguilla (AI)',
    },
    {
        id: 'AQ',
        value: 'AQ',
        label: 'Antartide (AQ)',
    },
    {
        id: 'AG',
        value: 'AG',
        label: 'Antigua e Barbuda (AG)',
    },
    {
        id: 'AR',
        value: 'AR',
        label: 'Argentina (AR)',
    },
    {
        id: 'AM',
        value: 'AM',
        label: 'Armenia (AM)',
    },
    {
        id: 'AW',
        value: 'AW',
        label: 'Aruba (AW)',
    },
    {
        id: 'AU',
        value: 'AU',
        label: 'Australia (AU)',
    },
    {
        id: 'AT',
        value: 'AT',
        label: 'Austria (AT)',
    },
    {
        id: 'AZ',
        value: 'AZ',
        label: 'Azerbaigian (AZ)',
    },
    {
        id: 'BS',
        value: 'BS',
        label: 'Bahamas (BS)',
    },
    {
        id: 'BH',
        value: 'BH',
        label: 'Bahrain (BH)',
    },
    {
        id: 'BD',
        value: 'BD',
        label: 'Bangladesh (BD)',
    },
    {
        id: 'BB',
        value: 'BB',
        label: 'Barbados (BB)',
    },
    {
        id: 'BY',
        value: 'BY',
        label: 'Bielorussia (BY)',
    },
    {
        id: 'BE',
        value: 'BE',
        label: 'Belgio (BE)',
    },
    {
        id: 'BZ',
        value: 'BZ',
        label: 'Belize (BZ)',
    },
    {
        id: 'BJ',
        value: 'BJ',
        label: 'Benin (BJ)',
    },
    {
        id: 'BM',
        value: 'BM',
        label: 'Bermuda (BM)',
    },
    {
        id: 'BT',
        value: 'BT',
        label: 'Bhutan (BT)',
    },
    {
        id: 'BO',
        value: 'BO',
        label: 'Bolivia (BO)',
    },
    {
        id: 'BA',
        value: 'BA',
        label: 'Bosnia ed Erzegovina (BA)',
    },
    {
        id: 'BW',
        value: 'BW',
        label: 'Botswana (BW)',
    },
    {
        id: 'BV',
        value: 'BV',
        label: 'Isola Bouvet (BV)',
    },
    {
        id: 'BR',
        value: 'BR',
        label: 'Brasile (BR)',
    },
    {
        id: 'IO',
        value: 'IO',
        label: "Territori Britannici dell'Oceano Indiano (IO)",
    },
    {
        id: 'BN',
        value: 'BN',
        label: 'Brunei (BN)',
    },
    {
        id: 'BG',
        value: 'BG',
        label: 'Bulgaria (BG)',
    },
    {
        id: 'BF',
        value: 'BF',
        label: 'Burkina Faso (BF)',
    },
    {
        id: 'BI',
        value: 'BI',
        label: 'Burundi (BI)',
    },
    {
        id: 'KH',
        value: 'KH',
        label: 'Cambogia (KH)',
    },
    {
        id: 'CM',
        value: 'CM',
        label: 'Camerun (CM)',
    },
    {
        id: 'CA',
        value: 'CA',
        label: 'Canada (CA)',
    },
    {
        id: 'CV',
        value: 'CV',
        label: 'Capo Verde (CV)',
    },
    {
        id: 'KY',
        value: 'KY',
        label: 'Isole Cayman (KY)',
    },
    {
        id: 'CF',
        value: 'CF',
        label: 'Repubblica Centrafricana (CF)',
    },
    {
        id: 'TD',
        value: 'TD',
        label: 'Ciad (TD)',
    },
    {
        id: 'CL',
        value: 'CL',
        label: 'Cile (CL)',
    },
    {
        id: 'CN',
        value: 'CN',
        label: 'Cina (CN)',
    },
    {
        id: 'CX',
        value: 'CX',
        label: 'Isola di Natale (CX)',
    },
    {
        id: 'CC',
        value: 'CC',
        label: 'Isole Cocos (Keeling) (CC)',
    },
    {
        id: 'CO',
        value: 'CO',
        label: 'Colombia (CO)',
    },
    {
        id: 'KM',
        value: 'KM',
        label: 'Comore (KM)',
    },
    {
        id: 'CG',
        value: 'CG',
        label: 'Congo (CG)',
    },
    {
        id: 'CD',
        value: 'CD',
        label: 'Repubblica Democratica del Congo (CD)',
    },
    {
        id: 'CK',
        value: 'CK',
        label: 'Isole Cook (CK)',
    },
    {
        id: 'CR',
        value: 'CR',
        label: 'Costa Rica (CR)',
    },
    {
        id: 'CI',
        value: 'CI',
        label: "Costa d'Avorio (CI)",
    },
    {
        id: 'HR',
        value: 'HR',
        label: 'Croazia (HR)',
    },
    {
        id: 'CU',
        value: 'CU',
        label: 'Cuba (CU)',
    },
    {
        id: 'CY',
        value: 'CY',
        label: 'Cipro (CY)',
    },
    {
        id: 'CZ',
        value: 'CZ',
        label: 'Repubblica Ceca (CZ)',
    },
    {
        id: 'DK',
        value: 'DK',
        label: 'Danimarca (DK)',
    },
    {
        id: 'DJ',
        value: 'DJ',
        label: 'Gibuti (DJ)',
    },
    {
        id: 'DM',
        value: 'DM',
        label: 'Dominica (DM)',
    },
    {
        id: 'DO',
        value: 'DO',
        label: 'Repubblica Dominicana (DO)',
    },
    {
        id: 'EC',
        value: 'EC',
        label: 'Ecuador (EC)',
    },
    {
        id: 'EG',
        value: 'EG',
        label: 'Egitto (EG)',
    },
    {
        id: 'SV',
        value: 'SV',
        label: 'El Salvador (SV)',
    },
    {
        id: 'GQ',
        value: 'GQ',
        label: 'Guinea Equatoriale (GQ)',
    },
    {
        id: 'ER',
        value: 'ER',
        label: 'Eritrea (ER)',
    },
    {
        id: 'EE',
        value: 'EE',
        label: 'Estonia (EE)',
    },
    {
        id: 'ET',
        value: 'ET',
        label: 'Ethiopia (ET)',
    },
    {
        id: 'FK',
        value: 'FK',
        label: 'Isole Falkland (Malvine) (FK)',
    },
    {
        id: 'FO',
        value: 'FO',
        label: 'Isole Faroe (FO)',
    },
    {
        id: 'FJ',
        value: 'FJ',
        label: 'Fiji (FJ)',
    },
    {
        id: 'FI',
        value: 'FI',
        label: 'Finlandia (FI)',
    },
    {
        id: 'FR',
        value: 'FR',
        label: 'Francia (FR)',
    },
    {
        id: 'GF',
        value: 'GF',
        label: 'Guyana francese (GF)',
    },
    {
        id: 'PF',
        value: 'PF',
        label: 'Polinesia Francese (PF)',
    },
    {
        id: 'TF',
        value: 'TF',
        label: 'Territori australi francesi (TF)',
    },
    {
        id: 'GA',
        value: 'GA',
        label: 'Gabon (GA)',
    },
    {
        id: 'GM',
        value: 'GM',
        label: 'Gambia (GM)',
    },
    {
        id: 'GE',
        value: 'GE',
        label: 'Georgia (GE)',
    },
    {
        id: 'DE',
        value: 'DE',
        label: 'Germania (DE)',
    },
    {
        id: 'GH',
        value: 'GH',
        label: 'Ghana (GH)',
    },
    {
        id: 'GI',
        value: 'GI',
        label: 'Gibilterra (GI)',
    },
    {
        id: 'GR',
        value: 'GR',
        label: 'Grecia (GR)',
    },
    {
        id: 'GL',
        value: 'GL',
        label: 'Groenlandia (GL)',
    },
    {
        id: 'GD',
        value: 'GD',
        label: 'Grenada (GD)',
    },
    {
        id: 'GP',
        value: 'GP',
        label: 'Guadalupa (GP)',
    },
    {
        id: 'GU',
        value: 'GU',
        label: 'Guam (GU)',
    },
    {
        id: 'GT',
        value: 'GT',
        label: 'Guatemala (GT)',
    },
    {
        id: 'GG',
        value: 'GG',
        label: 'Guernsey (GG)',
    },
    {
        id: 'GN',
        value: 'GN',
        label: 'Guinea (GN)',
    },
    {
        id: 'GW',
        value: 'GW',
        label: 'Guinea-Bissau (GW)',
    },
    {
        id: 'GY',
        value: 'GY',
        label: 'Guyana (GY)',
    },
    {
        id: 'HT',
        value: 'HT',
        label: 'Haiti (HT)',
    },
    {
        id: 'HM',
        value: 'HM',
        label: 'Isola Heard e Isole McDonald (HM)',
    },
    {
        id: 'VA',
        value: 'VA',
        label: 'Città del Vaticano (VA)',
    },
    {
        id: 'HN',
        value: 'HN',
        label: 'Honduras (HN)',
    },
    {
        id: 'HK',
        value: 'HK',
        label: 'Hong Kong (HK)',
    },
    {
        id: 'HU',
        value: 'HU',
        label: 'Ungheria (HU)',
    },
    {
        id: 'IS',
        value: 'IS',
        label: 'Islanda (IS)',
    },
    {
        id: 'IN',
        value: 'IN',
        label: 'India (IN)',
    },
    {
        id: 'ID',
        value: 'ID',
        label: 'Indonesia (ID)',
    },
    {
        id: 'IR',
        value: 'IR',
        label: 'Iran (IR)',
    },
    {
        id: 'IQ',
        value: 'IQ',
        label: 'Iraq (IQ)',
    },
    {
        id: 'IE',
        value: 'IE',
        label: 'Irlanda (IE)',
    },
    {
        id: 'IM',
        value: 'IM',
        label: 'Isola di Man (IM)',
    },
    {
        id: 'IL',
        value: 'IL',
        label: 'Israele (IL)',
    },
    {
        id: 'IT',
        value: 'IT',
        label: 'Italia (IT)',
    },
    {
        id: 'JM',
        value: 'JM',
        label: 'Giamaica (JM)',
    },
    {
        id: 'JP',
        value: 'JP',
        label: 'Giappone (JP)',
    },
    {
        id: 'JE',
        value: 'JE',
        label: 'Jersey (JE)',
    },
    {
        id: 'JO',
        value: 'JO',
        label: 'Giordania (JO)',
    },
    {
        id: 'KZ',
        value: 'KZ',
        label: 'Kazakistan (KZ)',
    },
    {
        id: 'KE',
        value: 'KE',
        label: 'Kenya (KE)',
    },
    {
        id: 'KI',
        value: 'KI',
        label: 'Kiribati (KI)',
    },
    {
        id: 'XK',
        value: 'XK',
        label: 'Kosovo (XK)',
    },
    {
        id: 'KP',
        value: 'KP',
        label: 'Corea del Nord (KP)',
    },
    {
        id: 'KR',
        value: 'KR',
        label: 'Corea del Sud (KR)',
    },
    {
        id: 'KW',
        value: 'KW',
        label: 'Kuwait (KW)',
    },
    {
        id: 'KG',
        value: 'KG',
        label: 'Kirghizistan (KG)',
    },
    {
        id: 'LA',
        value: 'LA',
        label: 'Laos (LA)',
    },
    {
        id: 'LV',
        value: 'LV',
        label: 'Lettonia (LV)',
    },
    {
        id: 'LB',
        value: 'LB',
        label: 'Libano (LB)',
    },
    {
        id: 'LS',
        value: 'LS',
        label: 'Lesotho (LS)',
    },
    {
        id: 'LR',
        value: 'LR',
        label: 'Liberia (LR)',
    },
    {
        id: 'LY',
        value: 'LY',
        label: 'Libia (LY)',
    },
    {
        id: 'LI',
        value: 'LI',
        label: 'Liechtenstein (LI)',
    },
    {
        id: 'LT',
        value: 'LT',
        label: 'Lituania (LT)',
    },
    {
        id: 'LU',
        value: 'LU',
        label: 'Lussemburgo (LU)',
    },
    {
        id: 'MO',
        value: 'MO',
        label: 'Macao (MO)',
    },
    {
        id: 'MK',
        value: 'MK',
        label: 'Macedonia del Nord (MK)',
    },
    {
        id: 'MG',
        value: 'MG',
        label: 'Madagascar (MG)',
    },
    {
        id: 'MW',
        value: 'MW',
        label: 'Malawi (MW)',
    },
    {
        id: 'MY',
        value: 'MY',
        label: 'Malesia (MY)',
    },
    {
        id: 'MV',
        value: 'MV',
        label: 'Maldive (MV)',
    },
    {
        id: 'ML',
        value: 'ML',
        label: 'Mali (ML)',
    },
    {
        id: 'MT',
        value: 'MT',
        label: 'Malta (MT)',
    },
    {
        id: 'MH',
        value: 'MH',
        label: 'Isole Marshall (MH)',
    },
    {
        id: 'MQ',
        value: 'MQ',
        label: 'Martinica (MQ)',
    },
    {
        id: 'MR',
        value: 'MR',
        label: 'Mauritania (MR)',
    },
    {
        id: 'MU',
        value: 'MU',
        label: 'Mauritius (MU)',
    },
    {
        id: 'YT',
        value: 'YT',
        label: 'Mayotte (YT)',
    },
    {
        id: 'MX',
        value: 'MX',
        label: 'Messico (MX)',
    },
    {
        id: 'FM',
        value: 'FM',
        label: 'Stati Federati di Micronesia (FM)',
    },
    {
        id: 'MD',
        value: 'MD',
        label: 'Moldavia (MD)',
    },
    {
        id: 'MC',
        value: 'MC',
        label: 'Monaco (MC)',
    },
    {
        id: 'MN',
        value: 'MN',
        label: 'Mongolia (MN)',
    },
    {
        id: 'ME',
        value: 'ME',
        label: 'Montenegro (ME)',
    },
    {
        id: 'MS',
        value: 'MS',
        label: 'Montserrat (MS)',
    },
    {
        id: 'MA',
        value: 'MA',
        label: 'Marocco (MA)',
    },
    {
        id: 'MZ',
        value: 'MZ',
        label: 'Mozambico (MZ)',
    },
    {
        id: 'MM',
        value: 'MM',
        label: 'Myanmar (MM)',
    },
    {
        id: 'NA',
        value: 'NA',
        label: 'Namibia (NA)',
    },
    {
        id: 'NR',
        value: 'NR',
        label: 'Nauru (NR)',
    },
    {
        id: 'NP',
        value: 'NP',
        label: 'Nepal (NP)',
    },
    {
        id: 'NL',
        value: 'NL',
        label: 'Paesi Bassi (NL)',
    },
    {
        id: 'AN',
        value: 'AN',
        label: 'Antille Olandesi (AN)',
    },
    {
        id: 'NC',
        value: 'NC',
        label: 'Nuova Caledonia (NC)',
    },
    {
        id: 'NZ',
        value: 'NZ',
        label: 'Nuova Zelanda (NZ)',
    },
    {
        id: 'NI',
        value: 'NI',
        label: 'Nicaragua (NI)',
    },
    {
        id: 'NE',
        value: 'NE',
        label: 'Niger (NE)',
    },
    {
        id: 'NG',
        value: 'NG',
        label: 'Nigeria (NG)',
    },
    {
        id: 'NU',
        value: 'NU',
        label: 'Niue (NU)',
    },
    {
        id: 'NF',
        value: 'NF',
        label: 'Isola Norfolk (NF)',
    },
    {
        id: 'MP',
        value: 'MP',
        label: 'Isole Marianne Settentrionali (MP)',
    },
    {
        id: 'NO',
        value: 'NO',
        label: 'Norvegia (NO)',
    },
    {
        id: 'OM',
        value: 'OM',
        label: 'Oman (OM)',
    },
    {
        id: 'PK',
        value: 'PK',
        label: 'Pakistan (PK)',
    },
    {
        id: 'PW',
        value: 'PW',
        label: 'Palau (PW)',
    },
    {
        id: 'PS',
        value: 'PS',
        label: 'Territori palestinesi (PS)',
    },
    {
        id: 'PA',
        value: 'PA',
        label: 'Panama (PA)',
    },
    {
        id: 'PG',
        value: 'PG',
        label: 'Papua Nuova Guinea (PG)',
    },
    {
        id: 'PY',
        value: 'PY',
        label: 'Paraguay (PY)',
    },
    {
        id: 'PE',
        value: 'PE',
        label: 'Peru (PE)',
    },
    {
        id: 'PH',
        value: 'PH',
        label: 'Filippine (PH)',
    },
    {
        id: 'PN',
        value: 'PN',
        label: 'Isole Pitcairn (PN)',
    },
    {
        id: 'PL',
        value: 'PL',
        label: 'Polonia (PL)',
    },
    {
        id: 'PT',
        value: 'PT',
        label: 'Portogallo (PT)',
    },
    {
        id: 'PR',
        value: 'PR',
        label: 'Porto Rico (PR)',
    },
    {
        id: 'QA',
        value: 'QA',
        label: 'Qatar (QA)',
    },
    {
        id: 'RE',
        value: 'RE',
        label: 'Riunione (RE)',
    },
    {
        id: 'RO',
        value: 'RO',
        label: 'Romania (RO)',
    },
    {
        id: 'RU',
        value: 'RU',
        label: 'Russia (RU)',
    },
    {
        id: 'RW',
        value: 'RW',
        label: 'Ruanda (RW)',
    },
    {
        id: 'SH',
        value: 'SH',
        label: "Sant'Elena (SH)",
    },
    {
        id: 'KN',
        value: 'KN',
        label: 'Saint Kitts e Nevis (KN)',
    },
    {
        id: 'LC',
        value: 'LC',
        label: 'Santa Lucia (LC)',
    },
    {
        id: 'PM',
        value: 'PM',
        label: 'Saint-Pierre e Miquelon (PM)',
    },
    {
        id: 'VC',
        value: 'VC',
        label: 'Saint Vincent e Grenadine (VC)',
    },
    {
        id: 'WS',
        value: 'WS',
        label: 'Samoa (WS)',
    },
    {
        id: 'SM',
        value: 'SM',
        label: 'San Marino (SM)',
    },
    {
        id: 'ST',
        value: 'ST',
        label: 'São Tomé e Príncipe (ST)',
    },
    {
        id: 'SA',
        value: 'SA',
        label: 'Arabia Saudita (SA)',
    },
    {
        id: 'SN',
        value: 'SN',
        label: 'Senegal (SN)',
    },
    {
        id: 'RS',
        value: 'RS',
        label: 'Serbia (RS)',
    },
    {
        id: 'SC',
        value: 'SC',
        label: 'Seychelles (SC)',
    },
    {
        id: 'SL',
        value: 'SL',
        label: 'Sierra Leone (SL)',
    },
    {
        id: 'SG',
        value: 'SG',
        label: 'Singapore (SG)',
    },
    {
        id: 'SK',
        value: 'SK',
        label: 'Slovacchia (SK)',
    },
    {
        id: 'SI',
        value: 'SI',
        label: 'Slovenia (SI)',
    },
    {
        id: 'SB',
        value: 'SB',
        label: 'Isole Salomone (SB)',
    },
    {
        id: 'SO',
        value: 'SO',
        label: 'Somalia (SO)',
    },
    {
        id: 'ZA',
        value: 'ZA',
        label: 'Sudafrica (ZA)',
    },
    {
        id: 'GS',
        value: 'GS',
        label: 'Georgia del Sud e Sandwich Australi (GS)',
    },
    {
        id: 'ES',
        value: 'ES',
        label: 'Spagna (ES)',
    },
    {
        id: 'LK',
        value: 'LK',
        label: 'Sri Lanka (LK)',
    },
    {
        id: 'SD',
        value: 'SD',
        label: 'Sudan (SD)',
    },
    {
        id: 'SR',
        value: 'SR',
        label: 'Suriname (SR)',
    },
    {
        id: 'SJ',
        value: 'SJ',
        label: 'Svalbard e Jan Mayen (SJ)',
    },
    {
        id: 'SZ',
        value: 'SZ',
        label: 'eSwatini (SZ)',
    },
    {
        id: 'SE',
        value: 'SE',
        label: 'Svezia (SE)',
    },
    {
        id: 'CH',
        value: 'CH',
        label: 'Svizzera (CH)',
    },
    {
        id: 'SY',
        value: 'SY',
        label: 'Siria (SY)',
    },
    {
        id: 'TW',
        value: 'TW',
        label: 'Taiwan (TW)',
    },
    {
        id: 'TJ',
        value: 'TJ',
        label: 'Tagikistan (TJ)',
    },
    {
        id: 'TZ',
        value: 'TZ',
        label: 'Tanzania (TZ)',
    },
    {
        id: 'TH',
        value: 'TH',
        label: 'Thailandia (TH)',
    },
    {
        id: 'TL',
        value: 'TL',
        label: 'Timor Est (TL)',
    },
    {
        id: 'TG',
        value: 'TG',
        label: 'Togo (TG)',
    },
    {
        id: 'TK',
        value: 'TK',
        label: 'Tokelau (TK)',
    },
    {
        id: 'TO',
        value: 'TO',
        label: 'Tonga (TO)',
    },
    {
        id: 'TT',
        value: 'TT',
        label: 'Trinidad e Tobago (TT)',
    },
    {
        id: 'TN',
        value: 'TN',
        label: 'Tunisia (TN)',
    },
    {
        id: 'TR',
        value: 'TR',
        label: 'Turchia (TR)',
    },
    {
        id: 'TM',
        value: 'TM',
        label: 'Turkmenistan (TM)',
    },
    {
        id: 'TC',
        value: 'TC',
        label: 'Isole Turks e Caicos (TC)',
    },
    {
        id: 'TV',
        value: 'TV',
        label: 'Tuvalu (TV)',
    },
    {
        id: 'UG',
        value: 'UG',
        label: 'Uganda (UG)',
    },
    {
        id: 'UA',
        value: 'UA',
        label: 'Ucraina (UA)',
    },
    {
        id: 'AE',
        value: 'AE',
        label: 'Emirati Arabi Uniti (AE)',
    },
    {
        id: 'GB',
        value: 'GB',
        label: 'Regno Unito (GB)',
    },
    {
        id: 'US',
        value: 'US',
        label: 'Stati Uniti (US)',
    },
    {
        id: 'UM',
        value: 'UM',
        label: 'Isole Minori Esterne degli Stati Uniti (UM)',
    },
    {
        id: 'UY',
        value: 'UY',
        label: 'Uruguay (UY)',
    },
    {
        id: 'UZ',
        value: 'UZ',
        label: 'Uzbekistan (UZ)',
    },
    {
        id: 'VU',
        value: 'VU',
        label: 'Vanuatu (VU)',
    },
    {
        id: 'VE',
        value: 'VE',
        label: 'Venezuela (VE)',
    },
    {
        id: 'VN',
        value: 'VN',
        label: 'Vietnam (VN)',
    },
    {
        id: 'VG',
        value: 'VG',
        label: 'Isole Vergini britanniche (VG)',
    },
    {
        id: 'VI',
        value: 'VI',
        label: 'Isole Vergini Americane (VI)',
    },
    {
        id: 'WF',
        value: 'WF',
        label: 'Wallis e Futuna (WF)',
    },
    {
        id: 'EH',
        value: 'EH',
        label: 'Sahara Occidentale (EH)',
    },
    {
        id: 'YE',
        value: 'YE',
        label: 'Yemen (YE)',
    },
    {
        id: 'ZM',
        value: 'ZM',
        label: 'Zambia (ZM)',
    },
    {
        id: 'ZW',
        value: 'ZW',
        label: 'Zimbabwe (ZW)',
    },
];

export const euCountries = [
    {
        id: 'AT',
        value: 'AT',
        label: 'Austria (AT)',
    },
    {
        id: 'BE',
        value: 'BE',
        label: 'Belgio (BE)',
    },
    {
        id: 'BG',
        value: 'BG',
        label: 'Bulgaria (BG)',
    },
    {
        id: 'HR',
        value: 'HR',
        label: 'Croazia (HR)',
    },
    {
        id: 'CY',
        value: 'CY',
        label: 'Cipro (CY)',
    },
    {
        id: 'CZ',
        value: 'CZ',
        label: 'Repubblica Ceca (CZ)',
    },
    {
        id: 'DE',
        value: 'DE',
        label: 'Germania (DE)',
    },
    {
        id: 'DK',
        value: 'DK',
        label: 'Danimarca (DK)',
    },
    {
        id: 'EE',
        value: 'EE',
        label: 'Estonia (EE)',
    },
    {
        id: 'FI',
        value: 'FI',
        label: 'Finlandia (FI)',
    },
    {
        id: 'FR',
        value: 'FR',
        label: 'Francia (FR)',
    },
    {
        id: 'GR',
        value: 'GR',
        label: 'Grecia (GR)',
    },
    {
        id: 'HU',
        value: 'HU',
        label: 'Ungheria (HU)',
    },
    {
        id: 'IE',
        value: 'IE',
        label: 'Irlanda (IE)',
    },
    {
        id: 'IT',
        value: 'IT',
        label: 'Italia (IT)',
    },
    {
        id: 'LV',
        value: 'LV',
        label: 'Lettonia (LV)',
    },
    {
        id: 'LT',
        value: 'LT',
        label: 'Lituania (LT)',
    },
    {
        id: 'LU',
        value: 'LU',
        label: 'Lussemburgo (LU)',
    },
    {
        id: 'MT',
        value: 'MT',
        label: 'Malta (MT)',
    },
    {
        id: 'NL',
        value: 'NL',
        label: 'Paesi Bassi (NL)',
    },
    {
        id: 'PL',
        value: 'PL',
        label: 'Polonia (PL)',
    },
    {
        id: 'PT',
        value: 'PT',
        label: 'Portogallo (PT)',
    },
    {
        id: 'RO',
        value: 'RO',
        label: 'Romania (RO)',
    },
    {
        id: 'SK',
        value: 'SK',
        label: 'Slovacchia (SK)',
    },
    {
        id: 'SI',
        value: 'SI',
        label: 'Slovenia (SI)',
    },
    {
        id: 'ES',
        value: 'ES',
        label: 'Spagna (ES)',
    },
    {
        id: 'ES',
        value: 'ES',
        label: 'Isole Canarie',
    },
    {
        id: 'SE',
        value: 'SE',
        label: 'Svezia (SE)',
    },
];

export const extraEuCountries = [
    {
        id: 'AF',
        value: 'AF',
        label: 'Afghanistan (AF)',
    },
    {
        id: 'AX',
        value: 'AX',
        label: 'Isole Åland (AX)',
    },
    {
        id: 'AL',
        value: 'AL',
        label: 'Albania (AL)',
    },
    {
        id: 'DZ',
        value: 'DZ',
        label: 'Algeria (DZ)',
    },
    {
        id: 'AS',
        value: 'AS',
        label: 'Samoa Americane (AS)',
    },
    {
        id: 'AD',
        value: 'AD',
        label: 'Andorra (AD)',
    },
    {
        id: 'AO',
        value: 'AO',
        label: 'Angola (AO)',
    },
    {
        id: 'AI',
        value: 'AI',
        label: 'Anguilla (AI)',
    },
    {
        id: 'AQ',
        value: 'AQ',
        label: 'Antartide (AQ)',
    },
    {
        id: 'AG',
        value: 'AG',
        label: 'Antigua e Barbuda (AG)',
    },
    {
        id: 'AR',
        value: 'AR',
        label: 'Argentina (AR)',
    },
    {
        id: 'AM',
        value: 'AM',
        label: 'Armenia (AM)',
    },
    {
        id: 'AW',
        value: 'AW',
        label: 'Aruba (AW)',
    },
    {
        id: 'AU',
        value: 'AU',
        label: 'Australia (AU)',
    },
    {
        id: 'AZ',
        value: 'AZ',
        label: 'Azerbaijan (AZ)',
    },
    {
        id: 'BS',
        value: 'BS',
        label: 'Bahamas (BS)',
    },
    {
        id: 'BH',
        value: 'BH',
        label: 'Bahrain (BH)',
    },
    {
        id: 'BD',
        value: 'BD',
        label: 'Bangladesh (BD)',
    },
    {
        id: 'BB',
        value: 'BB',
        label: 'Barbados (BB)',
    },
    {
        id: 'BY',
        value: 'BY',
        label: 'Bielorussia (BY)',
    },
    {
        id: 'BZ',
        value: 'BZ',
        label: 'Belize (BZ)',
    },
    {
        id: 'BJ',
        value: 'BJ',
        label: 'Benin (BJ)',
    },
    {
        id: 'BM',
        value: 'BM',
        label: 'Bermuda (BM)',
    },
    {
        id: 'BT',
        value: 'BT',
        label: 'Bhutan (BT)',
    },
    {
        id: 'BO',
        value: 'BO',
        label: 'Bolivia (BO)',
    },
    {
        id: 'BA',
        value: 'BA',
        label: 'Bosnia and Herzegovina (BA)',
    },
    {
        id: 'BW',
        value: 'BW',
        label: 'Botswana (BW)',
    },
    {
        id: 'BV',
        value: 'BV',
        label: 'Isola Bouvet (BV)',
    },
    {
        id: 'BR',
        value: 'BR',
        label: 'Brasile (BR)',
    },
    {
        id: 'IO',
        value: 'IO',
        label: "Territori Britannici dell'Oceano Indiano (IO)",
    },
    {
        id: 'BN',
        value: 'BN',
        label: 'Brunei (BN)',
    },
    {
        id: 'BF',
        value: 'BF',
        label: 'Burkina Faso (BF)',
    },
    {
        id: 'BI',
        value: 'BI',
        label: 'Burundi (BI)',
    },
    {
        id: 'KH',
        value: 'KH',
        label: 'Cambogia (KH)',
    },
    {
        id: 'CM',
        value: 'CM',
        label: 'Camerun (CM)',
    },
    {
        id: 'CA',
        value: 'CA',
        label: 'Canada (CA)',
    },
    {
        id: 'CV',
        value: 'CV',
        label: 'Capo Verde (CV)',
    },
    {
        id: 'KY',
        value: 'KY',
        label: 'Isole Cayman (KY)',
    },
    {
        id: 'CF',
        value: 'CF',
        label: 'Repubblica Centrafricana (CF)',
    },
    {
        id: 'TD',
        value: 'TD',
        label: 'Ciad (TD)',
    },
    {
        id: 'CL',
        value: 'CL',
        label: 'Cile (CL)',
    },
    {
        id: 'CN',
        value: 'CN',
        label: 'Cina (CN)',
    },
    {
        id: 'CX',
        value: 'CX',
        label: 'Isola di Natale (CX)',
    },
    {
        id: 'CC',
        value: 'CC',
        label: 'Isole Cocos (Keeling)',
    },
    {
        id: 'CO',
        value: 'CO',
        label: 'Colombia (CO)',
    },
    {
        id: 'KM',
        value: 'KM',
        label: 'Comore (KM)',
    },
    {
        id: 'CG',
        value: 'CG',
        label: 'Congo (CG)',
    },
    {
        id: 'CD',
        value: 'CD',
        label: 'Congo, The Democratic Republic of the (CD)',
    },
    {
        id: 'CK',
        value: 'CK',
        label: 'Isole Cook (CK)',
    },
    {
        id: 'CR',
        value: 'CR',
        label: 'Costa Rica (CR)',
    },
    {
        id: 'CI',
        value: 'CI',
        label: "Costa d'Avorio (CI)",
    },
    {
        id: 'CU',
        value: 'CU',
        label: 'Cuba (CU)',
    },
    {
        id: 'DJ',
        value: 'DJ',
        label: 'Gibuti (DJ)',
    },
    {
        id: 'DM',
        value: 'DM',
        label: 'Dominica (DM)',
    },
    {
        id: 'DO',
        value: 'DO',
        label: 'Repubblica Dominicana (DO)',
    },
    {
        id: 'EC',
        value: 'EC',
        label: 'Ecuador (EC)',
    },
    {
        id: 'EG',
        value: 'EG',
        label: 'Egitto (EG)',
    },
    {
        id: 'SV',
        value: 'SV',
        label: 'El Salvador (SV)',
    },
    {
        id: 'GQ',
        value: 'GQ',
        label: 'Guinea Equatoriale (GQ)',
    },
    {
        id: 'ER',
        value: 'ER',
        label: 'Eritrea (ER)',
    },
    {
        id: 'ET',
        value: 'ET',
        label: 'Etiopia (ET)',
    },
    {
        id: 'FK',
        value: 'FK',
        label: 'Isole Falkland (Malvine)',
    },
    {
        id: 'FO',
        value: 'FO',
        label: 'Isole Faroe (FO)',
    },
    {
        id: 'FJ',
        value: 'FJ',
        label: 'Figi (FJ)',
    },
    {
        id: 'GF',
        value: 'GF',
        label: 'Guyana francese (GF)',
    },
    {
        id: 'PF',
        value: 'PF',
        label: 'Polinesia Francese (PF)',
    },
    {
        id: 'TF',
        value: 'TF',
        label: 'Territori australi francesi (TF)',
    },
    {
        id: 'GA',
        value: 'GA',
        label: 'Gabon (GA)',
    },
    {
        id: 'GM',
        value: 'GM',
        label: 'Gambia (GM)',
    },
    {
        id: 'GE',
        value: 'GE',
        label: 'Georgia (GE)',
    },
    {
        id: 'GH',
        value: 'GH',
        label: 'Ghana (GH)',
    },
    {
        id: 'GI',
        value: 'GI',
        label: 'Gibilterra (GI)',
    },
    {
        id: 'GL',
        value: 'GL',
        label: 'Groenlandia (GL)',
    },
    {
        id: 'GD',
        value: 'GD',
        label: 'Grenada (GD)',
    },
    {
        id: 'GP',
        value: 'GP',
        label: 'Guadalupa (GP)',
    },
    {
        id: 'GU',
        value: 'GU',
        label: 'Guam (GU)',
    },
    {
        id: 'GT',
        value: 'GT',
        label: 'Guatemala (GT)',
    },
    {
        id: 'GG',
        value: 'GG',
        label: 'Guernsey (GG)',
    },
    {
        id: 'GN',
        value: 'GN',
        label: 'Guinea (GN)',
    },
    {
        id: 'GW',
        value: 'GW',
        label: 'Guinea-Bissau (GW)',
    },
    {
        id: 'GY',
        value: 'GY',
        label: 'Guyana (GY)',
    },
    {
        id: 'HT',
        value: 'HT',
        label: 'Haiti (HT)',
    },
    {
        id: 'HM',
        value: 'HM',
        label: 'Isola Heard e Isole McDonald (HM)',
    },
    {
        id: 'VA',
        value: 'VA',
        label: 'Città del Vaticano (VA)',
    },
    {
        id: 'HN',
        value: 'HN',
        label: 'Honduras (HN)',
    },
    {
        id: 'HK',
        value: 'HK',
        label: 'Hong Kong (HK)',
    },
    {
        id: 'IS',
        value: 'IS',
        label: 'Islanda (IS)',
    },
    {
        id: 'IN',
        value: 'IN',
        label: 'India (IN)',
    },
    {
        id: 'ID',
        value: 'ID',
        label: 'Indonesia (ID)',
    },
    {
        id: 'IR',
        value: 'IR',
        label: 'Iran (IR)',
    },
    {
        id: 'IQ',
        value: 'IQ',
        label: 'Iraq (IQ)',
    },
    {
        id: 'IM',
        value: 'IM',
        label: 'Isola di Man (IM)',
    },
    {
        id: 'IL',
        value: 'IL',
        label: 'Israele (IL)',
    },
    {
        id: 'JM',
        value: 'JM',
        label: 'Jamaica (JM)',
    },
    {
        id: 'JP',
        value: 'JP',
        label: 'Giappone (JP)',
    },
    {
        id: 'JE',
        value: 'JE',
        label: 'Jersey (JE)',
    },
    {
        id: 'JO',
        value: 'JO',
        label: 'Giordania (JO)',
    },
    {
        id: 'KZ',
        value: 'KZ',
        label: 'Kazakistan (KZ)',
    },
    {
        id: 'KE',
        value: 'KE',
        label: 'Kenya (KE)',
    },
    {
        id: 'KI',
        value: 'KI',
        label: 'Kiribati (KI)',
    },
    {
        id: 'XK',
        value: 'XK',
        label: 'Kosovo (XK)',
    },
    {
        id: 'KP',
        value: 'KP',
        label: 'Corea del Nord (KP)',
    },
    {
        id: 'KR',
        value: 'KR',
        label: 'Corea del Sud (KR)',
    },
    {
        id: 'KW',
        value: 'KW',
        label: 'Kuwait (KW)',
    },
    {
        id: 'KG',
        value: 'KG',
        label: 'Kirghizistan (KG)',
    },
    {
        id: 'LA',
        value: 'LA',
        label: 'Laos (LA)',
    },
    {
        id: 'LB',
        value: 'LB',
        label: 'Libano (LB)',
    },
    {
        id: 'LS',
        value: 'LS',
        label: 'Lesotho (LS)',
    },
    {
        id: 'LR',
        value: 'LR',
        label: 'Liberia (LR)',
    },
    {
        id: 'LY',
        value: 'LY',
        label: 'Libia (LY)',
    },
    {
        id: 'LI',
        value: 'LI',
        label: 'Liechtenstein (LI)',
    },
    {
        id: 'MO',
        value: 'MO',
        label: 'Macao (MO)',
    },
    {
        id: 'MK',
        value: 'MK',
        label: 'Macedonia del Nord (MK)',
    },
    {
        id: 'MG',
        value: 'MG',
        label: 'Madagascar (MG)',
    },
    {
        id: 'MW',
        value: 'MW',
        label: 'Malawi (MW)',
    },
    {
        id: 'MY',
        value: 'MY',
        label: 'Malesia (MY)',
    },
    {
        id: 'MV',
        value: 'MV',
        label: 'Maldive (MV)',
    },
    {
        id: 'ML',
        value: 'ML',
        label: 'Mali (ML)',
    },
    {
        id: 'MH',
        value: 'MH',
        label: 'Isole Marshall (MH)',
    },
    {
        id: 'MQ',
        value: 'MQ',
        label: 'Martinica (MQ)',
    },
    {
        id: 'MR',
        value: 'MR',
        label: 'Mauritania (MR)',
    },
    {
        id: 'MU',
        value: 'MU',
        label: 'Mauritius (MU)',
    },
    {
        id: 'YT',
        value: 'YT',
        label: 'Mayotte (YT)',
    },
    {
        id: 'MX',
        value: 'MX',
        label: 'Messico (MX)',
    },
    {
        id: 'FM',
        value: 'FM',
        label: 'Stati Federati di Micronesia (FM)',
    },
    {
        id: 'MD',
        value: 'MD',
        label: 'Moldavia (MD)',
    },
    {
        id: 'MC',
        value: 'MC',
        label: 'Monaco (MC)',
    },
    {
        id: 'MN',
        value: 'MN',
        label: 'Mongolia (MN)',
    },
    {
        id: 'ME',
        value: 'ME',
        label: 'Montenegro (ME)',
    },
    {
        id: 'MS',
        value: 'MS',
        label: 'Montserrat (MS)',
    },
    {
        id: 'MA',
        value: 'MA',
        label: 'Marocco (MA)',
    },
    {
        id: 'MZ',
        value: 'MZ',
        label: 'Mozambico (MZ)',
    },
    {
        id: 'MM',
        value: 'MM',
        label: 'Myanmar (Birmania) (MM)',
    },
    {
        id: 'NA',
        value: 'NA',
        label: 'Namibia (NA)',
    },
    {
        id: 'NR',
        value: 'NR',
        label: 'Nauru (NR)',
    },
    {
        id: 'NP',
        value: 'NP',
        label: 'Nepal (NP)',
    },
    {
        id: 'AN',
        value: 'AN',
        label: 'Antille Olandesi (AN)',
    },
    {
        id: 'NC',
        value: 'NC',
        label: 'Nuova Caledonia (NC)',
    },
    {
        id: 'NZ',
        value: 'NZ',
        label: 'Nuova Zelanda (NZ)',
    },
    {
        id: 'NI',
        value: 'NI',
        label: 'Nicaragua (NI)',
    },
    {
        id: 'NE',
        value: 'NE',
        label: 'Niger (NE)',
    },
    {
        id: 'NG',
        value: 'NG',
        label: 'Nigeria (NG)',
    },
    {
        id: 'NU',
        value: 'NU',
        label: 'Niue (NU)',
    },
    {
        id: 'NF',
        value: 'NF',
        label: 'Isola Norfolk (NF)',
    },
    {
        id: 'MP',
        value: 'MP',
        label: 'Isole Marianne Settentrionali (MP)',
    },
    {
        id: 'NO',
        value: 'NO',
        label: 'Norvegia (NO)',
    },
    {
        id: 'OM',
        value: 'OM',
        label: 'Oman (OM)',
    },
    {
        id: 'PK',
        value: 'PK',
        label: 'Pakistan (PK)',
    },
    {
        id: 'PW',
        value: 'PW',
        label: 'Palau (PW)',
    },
    {
        id: 'PS',
        value: 'PS',
        label: 'Territori palestinesi (PS)',
    },
    {
        id: 'PA',
        value: 'PA',
        label: 'Panama (PA)',
    },
    {
        id: 'PG',
        value: 'PG',
        label: 'Papua Nuova Guinea (PG)',
    },
    {
        id: 'PY',
        value: 'PY',
        label: 'Paraguay (PY)',
    },
    {
        id: 'PE',
        value: 'PE',
        label: 'Peru (PE)',
    },
    {
        id: 'PH',
        value: 'PH',
        label: 'Filippine (PH)',
    },
    {
        id: 'PN',
        value: 'PN',
        label: 'Isole Pitcairn (PN)',
    },
    {
        id: 'PR',
        value: 'PR',
        label: 'Porto Rico (PR)',
    },
    {
        id: 'QA',
        value: 'QA',
        label: 'Qatar (QA)',
    },
    {
        id: 'RE',
        value: 'RE',
        label: 'Riunione (RE)',
    },
    {
        id: 'RU',
        value: 'RU',
        label: 'Russia (RU)',
    },
    {
        id: 'RW',
        value: 'RW',
        label: 'RWANDA (RW)',
    },
    {
        id: 'SH',
        value: 'SH',
        label: "Sant'Elena (SH)",
    },
    {
        id: 'KN',
        value: 'KN',
        label: 'Saint Kitts e Nevis (KN)',
    },
    {
        id: 'LC',
        value: 'LC',
        label: 'Santa Lucia (LC)',
    },
    {
        id: 'PM',
        value: 'PM',
        label: 'Saint-Pierre e Miquelon (PM)',
    },
    {
        id: 'VC',
        value: 'VC',
        label: 'Saint Vincent e Grenadine (VC)',
    },
    {
        id: 'WS',
        value: 'WS',
        label: 'Samoa (WS)',
    },
    {
        id: 'SM',
        value: 'SM',
        label: 'San Marino (SM)',
    },
    {
        id: 'ST',
        value: 'ST',
        label: 'São Tomé e Príncipe (ST)',
    },
    {
        id: 'SA',
        value: 'SA',
        label: 'Arabia Saudita (SA)',
    },
    {
        id: 'SN',
        value: 'SN',
        label: 'Senegal (SN)',
    },
    {
        id: 'RS',
        value: 'RS',
        label: 'Serbia (RS)',
    },
    {
        id: 'SC',
        value: 'SC',
        label: 'Seychelles (SC)',
    },
    {
        id: 'SL',
        value: 'SL',
        label: 'Sierra Leone (SL)',
    },
    {
        id: 'SG',
        value: 'SG',
        label: 'Singapore (SG)',
    },
    {
        id: 'SB',
        value: 'SB',
        label: 'Isole Salomone (SB)',
    },
    {
        id: 'SO',
        value: 'SO',
        label: 'Somalia (SO)',
    },
    {
        id: 'ZA',
        value: 'ZA',
        label: 'Sudafrica (ZA)',
    },
    {
        id: 'GS',
        value: 'GS',
        label: 'Georgia del Sud e Sandwich Australi (GS)',
    },
    {
        id: 'LK',
        value: 'LK',
        label: 'Sri Lanka (LK)',
    },
    {
        id: 'SD',
        value: 'SD',
        label: 'Sudan (SD)',
    },
    {
        id: 'SR',
        value: 'SR',
        label: 'Suriname (SR)',
    },
    {
        id: 'SJ',
        value: 'SJ',
        label: 'Svalbard e Jan Mayen (SJ)',
    },
    {
        id: 'SZ',
        value: 'SZ',
        label: 'eSwatini (SZ)',
    },
    {
        id: 'CH',
        value: 'CH',
        label: 'Svizzera (CH)',
    },
    {
        id: 'SY',
        value: 'SY',
        label: 'Siria (SY)',
    },
    {
        id: 'TW',
        value: 'TW',
        label: 'Taiwan (TW)',
    },
    {
        id: 'TJ',
        value: 'TJ',
        label: 'Tagikistan (TJ)',
    },
    {
        id: 'TZ',
        value: 'TZ',
        label: 'Tanzania (TZ)',
    },
    {
        id: 'TH',
        value: 'TH',
        label: 'Thailandia (TH)',
    },
    {
        id: 'TL',
        value: 'TL',
        label: 'Timor Est (TL)',
    },
    {
        id: 'TG',
        value: 'TG',
        label: 'Togo (TG)',
    },
    {
        id: 'TK',
        value: 'TK',
        label: 'Tokelau (TK)',
    },
    {
        id: 'TO',
        value: 'TO',
        label: 'Tonga (TO)',
    },
    {
        id: 'TT',
        value: 'TT',
        label: 'Trinidad e Tobago (TT)',
    },
    {
        id: 'TN',
        value: 'TN',
        label: 'Tunisia (TN)',
    },
    {
        id: 'TR',
        value: 'TR',
        label: 'Turchia (TR)',
    },
    {
        id: 'TM',
        value: 'TM',
        label: 'Turkmenistan (TM)',
    },
    {
        id: 'TC',
        value: 'TC',
        label: 'Isole Turks e Caicos (TC)',
    },
    {
        id: 'TV',
        value: 'TV',
        label: 'Tuvalu (TV)',
    },
    {
        id: 'UG',
        value: 'UG',
        label: 'Uganda (UG)',
    },
    {
        id: 'UA',
        value: 'UA',
        label: 'Ucraina (UA)',
    },
    {
        id: 'AE',
        value: 'AE',
        label: 'Emirati Arabi Uniti (AE)',
    },
    {
        id: 'GB',
        value: 'GB',
        label: 'Regno Unito (GB)',
    },
    {
        id: 'US',
        value: 'US',
        label: 'Stati Uniti (US)',
    },
    {
        id: 'UM',
        value: 'UM',
        label: 'Isole Minori Esterne degli Stati Uniti (UM)',
    },
    {
        id: 'UY',
        value: 'UY',
        label: 'Uruguay (UY)',
    },
    {
        id: 'UZ',
        value: 'UZ',
        label: 'Uzbekistan (UZ)',
    },
    {
        id: 'VU',
        value: 'VU',
        label: 'Vanuatu (VU)',
    },
    {
        id: 'VE',
        value: 'VE',
        label: 'Venezuela (VE)',
    },
    {
        id: 'VN',
        value: 'VN',
        label: 'Vietnam (VN)',
    },
    {
        id: 'VG',
        value: 'VG',
        label: 'Isole Vergini britanniche (VG)',
    },
    {
        id: 'VI',
        value: 'VI',
        label: 'Isole Vergini Americane (VI)',
    },
    {
        id: 'WF',
        value: 'WF',
        label: 'Wallis e Futuna (WF)',
    },
    {
        id: 'EH',
        value: 'EH',
        label: 'Sahara Occidentale (EH)',
    },
    {
        id: 'YE',
        value: 'YE',
        label: 'Yemen (YE)',
    },
    {
        id: 'ZM',
        value: 'ZM',
        label: 'Zambia (ZM)',
    },
    {
        id: 'ZW',
        value: 'ZW',
        label: 'Zimbabwe (ZW)',
    },
];

export const currencies = [
    {
        id: 'EUR',
        value: 'EUR',
        label: 'Euro',
    },
    {
        id: 'AFA',
        value: 'AFA',
        label: 'Afghani',
    },
    {
        id: 'ALL',
        value: 'ALL',
        label: 'Lek albanese',
    },
    {
        id: 'DZD',
        value: 'DZD',
        label: 'Dinaro algerino',
    },
    {
        id: 'AOA',
        value: 'AOA',
        label: 'Kwanza angolano',
    },
    {
        id: 'ARS',
        value: 'ARS',
        label: 'Peso argentino',
    },
    {
        id: 'AMD',
        value: 'AMD',
        label: 'Dram armeno',
    },
    {
        id: 'AWG',
        value: 'AWG',
        label: 'Fiorino di Aruba',
    },
    {
        id: 'AUD',
        value: 'AUD',
        label: 'Dollaro australiano',
    },
    {
        id: 'AZN',
        value: 'AZN',
        label: 'Manat azero',
    },
    {
        id: 'BSD',
        value: 'BSD',
        label: 'Dollaro delle Bahamas',
    },
    {
        id: 'BHD',
        value: 'BHD',
        label: 'Dinaro del Bahrein',
    },
    {
        id: 'BDT',
        value: 'BDT',
        label: 'Taka bangladese',
    },
    {
        id: 'BBD',
        value: 'BBD',
        label: 'Dollaro di Barbados',
    },
    {
        id: 'BYR',
        value: 'BYR',
        label: 'Rublo bielorusso',
    },
    {
        id: 'BEF',
        value: 'BEF',
        label: 'Franco belga',
    },
    {
        id: 'BZD',
        value: 'BZD',
        label: 'Dollaro del Belize',
    },
    {
        id: 'BMD',
        value: 'BMD',
        label: 'Dollaro delle Bermuda',
    },
    {
        id: 'BTN',
        value: 'BTN',
        label: 'Ngultrum bhutanese',
    },
    {
        id: 'BTC',
        value: 'BTC',
        label: 'Bitcoin',
    },
    {
        id: 'BOB',
        value: 'BOB',
        label: 'Boliviano',
    },
    {
        id: 'BAM',
        value: 'BAM',
        label: 'Marco convertibile della Bosnia-Herzegovina',
    },
    {
        id: 'BWP',
        value: 'BWP',
        label: 'Pula del Botswana',
    },
    {
        id: 'BRL',
        value: 'BRL',
        label: 'Real brasiliano',
    },
    {
        id: 'GBP',
        value: 'GBP',
        label: 'Sterlina britannica',
    },
    {
        id: 'BND',
        value: 'BND',
        label: 'Dollaro del Brunei',
    },
    {
        id: 'BGN',
        value: 'BGN',
        label: 'Lev bulgaro',
    },
    {
        id: 'BIF',
        value: 'BIF',
        label: 'Franco del Burundi',
    },
    {
        id: 'KHR',
        value: 'KHR',
        label: 'Riel cambogiano',
    },
    {
        id: 'CAD',
        value: 'CAD',
        label: 'Dollaro canadese',
    },
    {
        id: 'CVE',
        value: 'CVE',
        label: 'Escudo capoverdiano',
    },
    {
        id: 'KYD',
        value: 'KYD',
        label: 'Dollaro delle Isole Cayman',
    },
    {
        id: 'XOF',
        value: 'XOF',
        label: 'Franco CFA BCEAO',
    },
    {
        id: 'XAF',
        value: 'XAF',
        label: 'Franco CFA BEAC',
    },
    {
        id: 'XPF',
        value: 'XPF',
        label: 'Franco CFP',
    },
    {
        id: 'CLP',
        value: 'CLP',
        label: 'Peso cileno',
    },
    {
        id: 'CLF',
        value: 'CLF',
        label: 'Unidades de fomento chilene',
    },
    {
        id: 'CNY',
        value: 'CNY',
        label: 'Renminbi cinese',
    },
    {
        id: 'COP',
        value: 'COP',
        label: 'Peso colombiano',
    },
    {
        id: 'KMF',
        value: 'KMF',
        label: 'Franco comoriano',
    },
    {
        id: 'CDF',
        value: 'CDF',
        label: 'Franco congolese',
    },
    {
        id: 'CRC',
        value: 'CRC',
        label: 'Colón costaricano',
    },
    {
        id: 'HRK',
        value: 'HRK',
        label: 'Kuna croata',
    },
    {
        id: 'CUC',
        value: 'CUC',
        label: 'Peso cubano convertibile',
    },
    {
        id: 'CZK',
        value: 'CZK',
        label: 'Corona ceca',
    },
    {
        id: 'DKK',
        value: 'DKK',
        label: 'Corona danese',
    },
    {
        id: 'DJF',
        value: 'DJF',
        label: 'Franco di Gibuti',
    },
    {
        id: 'DOP',
        value: 'DOP',
        label: 'Peso dominicano',
    },
    {
        id: 'XCD',
        value: 'XCD',
        label: 'Dollaro dei Caraibi orientali',
    },
    {
        id: 'EGP',
        value: 'EGP',
        label: 'Sterlina egiziana',
    },
    {
        id: 'ERN',
        value: 'ERN',
        label: 'Nakfa eritreo',
    },
    {
        id: 'EEK',
        value: 'EEK',
        label: 'Corona dell’Estonia',
    },
    {
        id: 'ETB',
        value: 'ETB',
        label: 'Birr etiope',
    },
    {
        id: 'FKP',
        value: 'FKP',
        label: 'Sterlina delle Falkland',
    },
    {
        id: 'FJD',
        value: 'FJD',
        label: 'Dollaro delle Figi',
    },
    {
        id: 'GMD',
        value: 'GMD',
        label: 'Dalasi gambiano',
    },
    {
        id: 'GEL',
        value: 'GEL',
        label: 'Lari georgiano',
    },
    {
        id: 'DEM',
        value: 'DEM',
        label: 'Marco tedesco',
    },
    {
        id: 'GHS',
        value: 'GHS',
        label: 'Cedi ghanese',
    },
    {
        id: 'GIP',
        value: 'GIP',
        label: 'Sterlina di Gibilterra',
    },
    {
        id: 'GRD',
        value: 'GRD',
        label: 'Dracma greca',
    },
    {
        id: 'GTQ',
        value: 'GTQ',
        label: 'Quetzal guatemalteco',
    },
    {
        id: 'GNF',
        value: 'GNF',
        label: 'Franco della Guinea',
    },
    {
        id: 'GYD',
        value: 'GYD',
        label: 'Dollaro della Guyana',
    },
    {
        id: 'HTG',
        value: 'HTG',
        label: 'Gourde haitiano',
    },
    {
        id: 'HNL',
        value: 'HNL',
        label: 'Lempira honduregna',
    },
    {
        id: 'HKD',
        value: 'HKD',
        label: 'Dollaro di Hong Kong',
    },
    {
        id: 'HUF',
        value: 'HUF',
        label: 'Fiorino ungherese',
    },
    {
        id: 'ISK',
        value: 'ISK',
        label: 'Corona islandese',
    },
    {
        id: 'INR',
        value: 'INR',
        label: 'Rupia indiana',
    },
    {
        id: 'IDR',
        value: 'IDR',
        label: 'Rupia indonesiana',
    },
    {
        id: 'IRR',
        value: 'IRR',
        label: 'Rial iraniano',
    },
    {
        id: 'IQD',
        value: 'IQD',
        label: 'Dinaro iracheno',
    },
    {
        id: 'ILS',
        value: 'ILS',
        label: 'Nuovo siclo israeliano',
    },
    {
        id: 'ITL',
        value: 'ITL',
        label: 'Lira italiana',
    },
    {
        id: 'JMD',
        value: 'JMD',
        label: 'Dollaro giamaicano',
    },
    {
        id: 'JPY',
        value: 'JPY',
        label: 'Yen giapponese',
    },
    {
        id: 'JOD',
        value: 'JOD',
        label: 'Dinaro giordano',
    },
    {
        id: 'KZT',
        value: 'KZT',
        label: 'Tenge kazako',
    },
    {
        id: 'KES',
        value: 'KES',
        label: 'Scellino keniota',
    },
    {
        id: 'KWD',
        value: 'KWD',
        label: 'Dinaro kuwaitiano',
    },
    {
        id: 'KGS',
        value: 'KGS',
        label: 'Som kirghiso',
    },
    {
        id: 'LAK',
        value: 'LAK',
        label: 'Kip laotiano',
    },
    {
        id: 'LVL',
        value: 'LVL',
        label: 'Lats lettone',
    },
    {
        id: 'LBP',
        value: 'LBP',
        label: 'Lira libanese',
    },
    {
        id: 'LSL',
        value: 'LSL',
        label: 'Loti del Lesotho',
    },
    {
        id: 'LRD',
        value: 'LRD',
        label: 'Dollaro liberiano',
    },
    {
        id: 'LYD',
        value: 'LYD',
        label: 'Dinaro libico',
    },
    {
        id: 'LTC',
        value: 'LTC',
        label: 'Litecoin',
    },
    {
        id: 'LTL',
        value: 'LTL',
        label: 'Litas lituano',
    },
    {
        id: 'MOP',
        value: 'MOP',
        label: 'Pataca di Macao',
    },
    {
        id: 'MKD',
        value: 'MKD',
        label: 'Dinaro macedone',
    },
    {
        id: 'MGA',
        value: 'MGA',
        label: 'Ariary malgascio',
    },
    {
        id: 'MWK',
        value: 'MWK',
        label: 'Kwacha malawiano',
    },
    {
        id: 'MYR',
        value: 'MYR',
        label: 'Ringgit malese',
    },
    {
        id: 'MVR',
        value: 'MVR',
        label: 'Rufiyaa delle Maldive',
    },
    {
        id: 'MRO',
        value: 'MRO',
        label: 'Ouguiya della Mauritania',
    },
    {
        id: 'MUR',
        value: 'MUR',
        label: 'Rupia mauriziana',
    },
    {
        id: 'MXN',
        value: 'MXN',
        label: 'Peso messicano',
    },
    {
        id: 'MDL',
        value: 'MDL',
        label: 'Leu moldavo',
    },
    {
        id: 'MNT',
        value: 'MNT',
        label: 'Tugrik mongolo',
    },
    {
        id: 'MAD',
        value: 'MAD',
        label: 'Dirham marocchino',
    },
    {
        id: 'MZM',
        value: 'MZM',
        label: 'Metical mozambicano',
    },
    {
        id: 'MMK',
        value: 'MMK',
        label: 'Kyat di Myanmar',
    },
    {
        id: 'NAD',
        value: 'NAD',
        label: 'Dollaro namibiano',
    },
    {
        id: 'NPR',
        value: 'NPR',
        label: 'Rupia nepalese',
    },
    {
        id: 'ANG',
        value: 'ANG',
        label: 'Fiorino delle Antille olandesi',
    },
    {
        id: 'TWD',
        value: 'TWD',
        label: 'Nuovo dollaro taiwanese',
    },
    {
        id: 'NZD',
        value: 'NZD',
        label: 'Dollaro neozelandese',
    },
    {
        id: 'NIO',
        value: 'NIO',
        label: 'Córdoba nicaraguense',
    },
    {
        id: 'NGN',
        value: 'NGN',
        label: 'Naira nigeriana',
    },
    {
        id: 'KPW',
        value: 'KPW',
        label: 'Won nordcoreano',
    },
    {
        id: 'NOK',
        value: 'NOK',
        label: 'Corona norvegese',
    },
    {
        id: 'OMR',
        value: 'OMR',
        label: 'Rial omanita',
    },
    {
        id: 'PKR',
        value: 'PKR',
        label: 'Rupia pakistana',
    },
    {
        id: 'PAB',
        value: 'PAB',
        label: 'Balboa panamense',
    },
    {
        id: 'PGK',
        value: 'PGK',
        label: 'Kina papuana',
    },
    {
        id: 'PYG',
        value: 'PYG',
        label: 'Guaraní paraguayano',
    },
    {
        id: 'PEN',
        value: 'PEN',
        label: 'Sol peruviano',
    },
    {
        id: 'PHP',
        value: 'PHP',
        label: 'Peso filippino',
    },
    {
        id: 'PLN',
        value: 'PLN',
        label: 'Zloty polacco',
    },
    {
        id: 'QAR',
        value: 'QAR',
        label: 'Rial qatariano',
    },
    {
        id: 'RON',
        value: 'RON',
        label: 'Leu rumeno',
    },
    {
        id: 'RUB',
        value: 'RUB',
        label: 'Rublo russo',
    },
    {
        id: 'RWF',
        value: 'RWF',
        label: 'Franco ruandese',
    },
    {
        id: 'SVC',
        value: 'SVC',
        label: 'Colón salvadoregno',
    },
    {
        id: 'WST',
        value: 'WST',
        label: 'Tala samoano',
    },
    {
        id: 'STD',
        value: 'STD',
        label: 'Dobra di São Tomé e Príncipe',
    },
    {
        id: 'SAR',
        value: 'SAR',
        label: 'Riyal saudita',
    },
    {
        id: 'RSD',
        value: 'RSD',
        label: 'Dinaro serbo',
    },
    {
        id: 'SCR',
        value: 'SCR',
        label: 'Rupia delle Seychelles',
    },
    {
        id: 'SLL',
        value: 'SLL',
        label: 'Leone della Sierra Leone',
    },
    {
        id: 'SGD',
        value: 'SGD',
        label: 'Dollaro di Singapore',
    },
    {
        id: 'SKK',
        value: 'SKK',
        label: 'Corona slovacca',
    },
    {
        id: 'SBD',
        value: 'SBD',
        label: 'Dollaro delle Isole Salomone',
    },
    {
        id: 'SOS',
        value: 'SOS',
        label: 'Scellino somalo',
    },
    {
        id: 'ZAR',
        value: 'ZAR',
        label: 'Rand sudafricano',
    },
    {
        id: 'KRW',
        value: 'KRW',
        label: 'Won sudcoreano',
    },
    {
        id: 'SSP',
        value: 'SSP',
        label: 'Sterlina sud-sudanese',
    },
    {
        id: 'XDR',
        value: 'XDR',
        label: 'Diritti speciali di prelievo',
    },
    {
        id: 'LKR',
        value: 'LKR',
        label: 'Rupia di Sri Lanka',
    },
    {
        id: 'SHP',
        value: 'SHP',
        label: 'Sterlina di Sant’Elena',
    },
    {
        id: 'SDG',
        value: 'SDG',
        label: 'Sterlina sudanese',
    },
    {
        id: 'SRD',
        value: 'SRD',
        label: 'Dollaro del Suriname',
    },
    {
        id: 'SZL',
        value: 'SZL',
        label: 'Lilangeni dello Swaziland',
    },
    {
        id: 'SEK',
        value: 'SEK',
        label: 'Corona svedese',
    },
    {
        id: 'CHF',
        value: 'CHF',
        label: 'Franco svizzero',
    },
    {
        id: 'SYP',
        value: 'SYP',
        label: 'Lira siriana',
    },
    {
        id: 'TJS',
        value: 'TJS',
        label: 'Somoni tagiko',
    },
    {
        id: 'TZS',
        value: 'TZS',
        label: 'Scellino della Tanzania',
    },
    {
        id: 'THB',
        value: 'THB',
        label: 'Baht thailandese',
    },
    {
        id: 'TOP',
        value: 'TOP',
        label: 'Paʻanga tongano',
    },
    {
        id: 'TTD',
        value: 'TTD',
        label: 'Dollaro di Trinidad e Tobago',
    },
    {
        id: 'TND',
        value: 'TND',
        label: 'Dinaro tunisino',
    },
    {
        id: 'TRY',
        value: 'TRY',
        label: 'Lira turca',
    },
    {
        id: 'TMT',
        value: 'TMT',
        label: 'Manat turkmeno',
    },
    {
        id: 'UGX',
        value: 'UGX',
        label: 'Scellino ugandese',
    },
    {
        id: 'UAH',
        value: 'UAH',
        label: 'Grivnia ucraina',
    },
    {
        id: 'AED',
        value: 'AED',
        label: 'Dirham degli Emirati Arabi Uniti',
    },
    {
        id: 'UYU',
        value: 'UYU',
        label: 'Peso uruguayano',
    },
    {
        id: 'USD',
        value: 'USD',
        label: 'Dollaro statunitense',
    },
    {
        id: 'UZS',
        value: 'UZS',
        label: 'Sum uzbeco',
    },
    {
        id: 'VUV',
        value: 'VUV',
        label: 'Vatu di Vanuatu',
    },
    {
        id: 'VEF',
        value: 'VEF',
        label: 'Bolívar venezuelano',
    },
    {
        id: 'VND',
        value: 'VND',
        label: 'Dong vietnamita',
    },
    {
        id: 'YER',
        value: 'YER',
        label: 'Riyal yemenita',
    },
    {
        id: 'ZMK',
        value: 'ZMK',
        label: 'Kwacha zambiano',
    },
    {
        id: 'ZWL',
        value: 'ZWL',
        label: 'Dollaro zimbabwese',
    },
];
